var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "auth-login" },
    [
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.form, "label-width": "80px" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "团队ID" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.corpId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "corpId", $$v)
                  },
                  expression: "form.corpId",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "用户ID" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.userId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "userId", $$v)
                  },
                  expression: "form.userId",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                [_vm._v("登录")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }